import React from "react";
import {
  Alert,
  Chip,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

const formatValue = (card) => {
  if (!card?.available) return "Unavailable";
  if (card.value === null || card.value === undefined || card.value === "") return "-";
  if (card.key?.includes("revenue")) {
    const n = Number(card.value || 0);
    return Number.isFinite(n) ? `$${n.toFixed(2)}` : String(card.value);
  }
  const n = Number(card.value);
  return Number.isFinite(n) ? n.toLocaleString() : String(card.value);
};

const chipColor = (severity) => {
  if (severity === "success") return "success";
  if (severity === "warning") return "warning";
  if (severity === "primary") return "primary";
  return "default";
};

export default function RepricingOverview({ shell }) {
  const cards = Array.isArray(shell?.overview_cards) ? shell.overview_cards : [];
  const warnings = Array.isArray(shell?.store_signal_warnings) ? shell.store_signal_warnings : [];

  return (
    <Stack spacing={1.5} sx={{ mb: 2 }}>
      {!!warnings.length && (
        <Alert severity="warning">
          Some store metrics are unavailable: {warnings.join(", ")}.
        </Alert>
      )}

      <Grid container spacing={2}>
        {cards.map((card) => (
          <Grid item xs={12} sm={6} md={4} lg={2} key={card.key}>
            <Paper variant="outlined" sx={{ p: 2, height: "100%" }}>
              <Stack spacing={1}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                  <Typography variant="body2" color="text.secondary">
                    {card.label}
                  </Typography>
                  <Chip
                    size="small"
                    color={chipColor(card.severity)}
                    variant={card.available ? "filled" : "outlined"}
                    label={card.available ? "Live" : "Missing"}
                  />
                </Stack>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  {formatValue(card)}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {card.helper}
                </Typography>
              </Stack>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
